module.exports = __webpack_public_path__ + "img/djen.25857b42.jpg";